import api from './client';
import { BillingInvoice, BillingRunSummary, IntegratorBilling, UpdateBillingRequest } from '../types';

export interface BillingPriceList {
  standardNet: number;
  proNet: number;
}

/** Miesięczny budżet AI integratora (USD): efektywny próg, nadpisanie, domyślny i wydatek MTD. */
export interface AiBudgetInfo {
  effectiveUsd: number;
  overrideUsd: number | null;
  defaultUsd: number;
  spentThisMonthUsd: number;
}

export const billingApi = {
  pricing: () => api.get<BillingPriceList>('/api/admin/billing/pricing'),
  list: () => api.get<IntegratorBilling[]>('/api/admin/billing/integrators'),
  update: (id: string, data: UpdateBillingRequest) =>
    api.put<IntegratorBilling>(`/api/admin/billing/integrators/${id}`, data),
  invoices: (id: string) => api.get<BillingInvoice[]>(`/api/admin/billing/integrators/${id}/invoices`),
  run: () => api.post<BillingRunSummary>('/api/admin/billing/run'),
  aiBudget: (id: string) => api.get<AiBudgetInfo>(`/api/admin/billing/integrators/${id}/ai-budget`),
  setAiBudget: (id: string, budgetUsd: number | null) =>
    api.put<AiBudgetInfo>(`/api/admin/billing/integrators/${id}/ai-budget`, { budgetUsd }),
};
